import React, { Component } from 'react'
import { FormControl, TextField } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { DatePicker } from '@material-ui/pickers';
import { parsePlainDate, toPlainDateString } from '../../../../utils/DateUtils';

export class DateInput extends Component {
  render() {
    const { required, classes, label, id, formState, onChangeHandler, inputId, t, defaultValue, readOnly } = this.props;
    const error = Boolean(formState.errors[id]);
    const inputLabel = required ? required(t(label)) : t(label);
    const rawValue = toPlainDateString(formState.mappedData[inputId] || defaultValue || '');
    const dateValue = rawValue ? parsePlainDate(rawValue) : null;

    const handleChange = date => {
      onChangeHandler([inputId], toPlainDateString(date) || '');
    };

    const renderTextField = textFieldProps => (
      <TextField
        {...textFieldProps}
        className={classes.input}
        style={{ width: 250 }}
      />
    );

    return (
      <FormControl className={classes.formControl}  key={"formControl"+id}>
        <DatePicker
          autoOk
          clearable
          id={id}
          label={inputLabel}
          format='P'
          inputVariant='outlined'
          value={dateValue}
          onChange={handleChange}
          disabled={readOnly}
          error={error}
          helperText={error ? formState.errors[id] : ''}
          TextFieldComponent={renderTextField}
        />
      </FormControl>
    )
  }
}

export default withTranslation('fieldLabels')(DateInput);
